<!-- 

When adding multiple instances of the editable textarea to a single parent, use the fieldId prop to identify the textarea.

Otherwise, both text areas will edit the same field, even if they don't show it in the UI.

-->

<script setup lang="ts">

import { ref, computed } from 'vue'

const props = defineProps({
    text: {
        type: String 
    },
    placeholder: {
        type: String,
    },
    taskId: {
        type: String,
        required: false
    },
    fieldId: {
        type: String,
        required: false
    }
})

const emits = defineEmits(["editCompleted", "cancelEdit"])


const isEditing = ref<boolean>(false)

// Generate unique ID for this component instance
const componentId = computed(() => props.fieldId || `editableTextarea-${Math.random().toString(36).substr(2, 9)}`)

const startEdit = () => {
    isEditing.value = true
}

const handleNewLine = ((e) => {

    const editableDiv = document.getElementById(componentId.value)

    if(e.keyCode === 13){
        e.preventDefault();
        const selection = window.getSelection();
        const cursorPosition = selection.focusOffset;
        const text = editableDiv.textContent;
        const newText = text.slice(0, cursorPosition) + '\n' + text.slice(cursorPosition);
        editableDiv.textContent = newText;
        const newCursorPosition = cursorPosition + 1;
        const newRange = document.createRange();
        newRange.setStart(editableDiv.childNodes[0], newCursorPosition);
        newRange.setEnd(editableDiv.childNodes[0], newCursorPosition);
        selection.removeAllRanges();
        selection.addRange(newRange);
  }
})

const completeEdit = async () => {
    console.log(document.getElementById(componentId.value)?.innerHTML)
    const newDescription = document.getElementById(componentId.value)?.innerText
    if(newDescription && newDescription !== props.text){
        emits("editCompleted", newDescription)
    }

    isEditing.value = false

}


const cancelEdit = () => {
    isEditing.value = false
    emits("cancelEdit")
}

</script>

<template>
    <div class="description-container">
        <div 
        
        :id="componentId"
        :contenteditable="isEditing" 
        @dblclick="startEdit"
        @keyup.esc="cancelEdit"
        @blur="completeEdit"
        @keydown.enter="handleNewLine"
        class="task-desc"
        :class="{ 'desc-editing': isEditing,  }"
        
        >
            {{ props.text ? props.text : props.placeholder }}
    </div>
    </div>
</template>

<style scoped>

.description-container{
    margin-top: 1.8rem;
}


.task-desc{
    font-family: var(--gidole);
    color: var(--task-text-main);
    font-size:1.6rem;
    line-height: 145%;
    cursor: pointer;
    margin: 0 auto;
    white-space: pre-wrap;
    min-height: 1rem;
    user-select: none;
    transition: all .2s ease-in-out;
}

.task-desc:hover{
    background-color: var(--box-color);
    padding: 1.6rem;

}

.desc-editing{
    outline: 1px solid var(--main-text-color);
    background-color: var(--box-color);
    padding: 1rem .5rem;
    cursor: text;
    border-radius: 6px;
    user-select: all;
}


</style>